import React, { createContext, useContext } from "react";

export const PlanYearContext = createContext<number | undefined>(undefined);

export const usePlanYear = () => {
  const context = useContext(PlanYearContext);
  if (context === undefined) {
    throw new Error("usePlanYear must be used within a PlanYearProvider");
  }
  return context;
};

export const PlanYearProvider: React.FC<{ planYear: number; children: React.ReactNode }> = ({ planYear, children }) => {
  return <PlanYearContext.Provider value={planYear}>{children}</PlanYearContext.Provider>;
};
